jQuery(document).ready(function ($) {
	$('.carousel')
		.carousel({
			interval: 8000
		});
});